import { Action } from 'redux'
import { contentUpdate } from '~/app/store/content'
/* eslint-disable @typescript-eslint/no-explicit-any */
//TODO MIGRATION T011: Fix eslint errors

export const REFINEMENT_UPDATE = 'REFINEMENT_UPDATE'

interface RefinementUpdatePayload {
  add?: State.Refinement[]
  remove?: State.Refinement[]
  removeAll?: boolean
}

export interface RefinementUpdateAction extends Action {
  type: string
  payload: RefinementUpdatePayload
}

export const buildRefinement = (value: string, dimension: string, other?: Record<string, any>): State.Refinement => ({
  value,
  dimension,
  ...other,
})

export const refinementBulkUpdate = (
  refinementToAdd?: State.Refinement[],
  refinementToRemove?: State.Refinement[],
  removeAll?: boolean,
): RefinementUpdateAction => ({
  payload: {
    add: refinementToAdd,
    remove: refinementToRemove,
    removeAll,
  },
  type: REFINEMENT_UPDATE,
})

export const refinementAddAndRemove = (
  refinementToAdd?: State.Refinement[],
  refinementToRemove?: State.Refinement[],
  removeAll?: boolean,
): Gallery.ContentQuery.Action =>
  contentUpdate({
    actions: refinementBulkUpdate(refinementToAdd, refinementToRemove, removeAll),
  })

export const refinementAdd = (refinement: State.Refinement[]): Gallery.ContentQuery.Action => refinementAddAndRemove(refinement, undefined)

export const refinementRemove = (refinement: State.Refinement[], removeAll?: boolean): Gallery.ContentQuery.Action =>
  refinementAddAndRemove(undefined, refinement, removeAll)
